var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 39,
    viewBox: "0 0 28 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5625 7.875C17.5625 5.94531 15.9297 4.3125 14 4.3125C11.9961 4.3125 10.4375 5.94531 10.4375 7.875V19.75C10.4375 21.7539 11.9961 23.3125 14 23.3125C15.9297 23.3125 17.5625 21.7539 17.5625 19.75V7.875ZM6.875 7.875C6.875 3.94141 10.0664 0.75 14 0.75C17.9336 0.75 21.125 3.94141 21.125 7.875V19.75C21.125 23.6836 17.9336 26.875 14 26.875C10.0664 26.875 6.875 23.6836 6.875 19.75V7.875ZM4.5 16.7812V19.75C4.5 25.0195 8.73047 29.25 14 29.25C19.1953 29.25 23.5 25.0195 23.5 19.75V16.7812C23.5 15.8164 24.2422 15 25.2812 15C26.2461 15 27.0625 15.8164 27.0625 16.7812V19.75C27.0625 26.4297 22.0898 31.8477 15.7812 32.7383V35.1875H19.3438C20.3086 35.1875 21.125 36.0039 21.125 36.9688C21.125 38.0078 20.3086 38.75 19.3438 38.75H14H8.65625C7.61719 38.75 6.875 38.0078 6.875 36.9688C6.875 36.0039 7.61719 35.1875 8.65625 35.1875H12.2188V32.7383C5.83594 31.8477 0.9375 26.4297 0.9375 19.75V16.7812C0.9375 15.8164 1.67969 15 2.71875 15C3.68359 15 4.5 15.8164 4.5 16.7812Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.a4774fa14490fda3489ae181dcfe3cc3.svg";
export { ForwardRef as ReactComponent };